import { useState } from "react";

import { useAuth } from "@warden-ui/common";
import { parseQueryString, parseAmplifyConfig } from "@warden-ui/common";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CardContentSignInMfa } from "@warden-ui/card-components";
import { CPPageBody } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

const defaultQueryString: {[key: string]: string} = {
  email: "",
  region: "",
}

export default function SigninMfa() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = parseAmplifyConfig(queryString);
  auth.configureAmplify(amplifyConfig);

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const configureFailed = () => {
    if (!auth.isConfigured) {
      console.error("Auth is not configured.");
      return true;
    }
    return false;
  }

  const onClickMfaSignin = async (code: string) => {
    if (configureFailed()) {
      return;
    }

    if (code.length === 0) {
      setErrorMessage(t('digit_code.error.empty'));
      return;
    }

    if (code.length !== 6) {
      setErrorMessage(t('digit_code.error.short'));
      return;
    }

    setLoading(true);
    const result = await auth.sendMfaCode(code, amplifyConfig);
    if (result.success) {
      setErrorMessage("");
    } else {
      setErrorMessage(result.message);
    }
    setLoading(false);
  };

  if (auth.isSignedIn) {
    navigate(`/redirect?${searchParams.toString()}`);
  }

  return (
    <CPPageBody
      onBackClicked={() => {
        navigate(`/?${searchParams.toString()}`);
      }}
    >
      <CardContentSignInMfa
        email={queryString.email}
        onClickMfaSignin={onClickMfaSignin}
        errorMessage={errorMessage}
        loading={loading}
      />
    </CPPageBody>
  );
}
